import { ChangeDetectorRef, Injector, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { Observable } from 'rxjs';
import { take, map } from 'rxjs/operators';

import { Classifier } from '../classifier';

import { PartyIdentificationGlossaryService } from './party-identification-glossary.service';
import { PartyIdentificationType } from './party-identification';

@Pipe({
  name: 'partyIdentificationCodeType',
  pure: false,
  standalone: false
})
export class PartyIdentificationCodeTypePipe implements PipeTransform, OnDestroy {
  private asyncPipe: AsyncPipe;

  constructor(
    private partyIdentificationGlossaryService: PartyIdentificationGlossaryService,
    private injector: Injector
  ) {
    this.asyncPipe = new AsyncPipe(injector.get(ChangeDetectorRef));
  }

  ngOnDestroy(): void {
    this.asyncPipe.ngOnDestroy();
  }

  transform(value: string, type: PartyIdentificationType): string {
    if (!type) {
      throw new Error('type param not provided');
    }

    if (!value) {
      return '';
    }

    switch (type) {
      case PartyIdentificationType.PRIVATE:
        return this.asyncTransform(value, this.partyIdentificationGlossaryService.personIdentificationCodeTypes$);
      case PartyIdentificationType.ORGANISATION:
        return this.asyncTransform(value, this.partyIdentificationGlossaryService.organizationIdentificationCodeTypes$);
    }
  }

  private asyncTransform(value: unknown, classifiers$: Observable<Classifier[]>) {
    return this.asyncPipe.transform(
      classifiers$.pipe(
        take(1),
        map((classifiers) => classifiers.find((classifier) => classifier.id === value)?.label)
      )
    );
  }
}
